import { useId, type ReactNode } from 'react';
import { X } from 'lucide-react';
import { useT } from '../i18n';
import { IconButton } from './IconButton';
import { Overlay } from './Overlay';
import { cx } from './cx';
import s from './Modal.module.css';

export interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  description?: ReactNode;
  children?: ReactNode;
  /** Zone de boutons en pied de modale. */
  footer?: ReactNode;
  size?: 'sm' | 'md' | 'lg';
  role?: 'dialog' | 'alertdialog';
}

export function Modal({ open, onClose, title, description, children, footer, size = 'md', role }: ModalProps) {
  const { t } = useT();
  const titleId = useId();
  return (
    <Overlay
      open={open}
      onClose={onClose}
      labelledBy={titleId}
      role={role}
      backdropClass={s.backdrop}
      panelClass={cx(s.panel, s[size])}
    >
      <header className={s.header}>
        <div>
          <h2 id={titleId} className={s.title}>
            {title}
          </h2>
          {description && <p className={s.desc}>{description}</p>}
        </div>
        <IconButton label={t('ui.close')} icon={<X size={18} />} size="sm" onClick={onClose} />
      </header>
      {children && <div className={s.body}>{children}</div>}
      {footer && <footer className={s.footer}>{footer}</footer>}
    </Overlay>
  );
}
